import {
  addItem,
  removeItem,
} from '@/api/gen/quizset-folder-controller/quizset-folder-controller.gen';

import type { Folder } from '../../types/folder.types';
import { toFolder } from '../folder.adapters';

import { fetchFolderDetail } from './folder';

export const addFolderItem = async (
  id: string,
  quizsetId: string,
  confirmSourcePublication = false,
): Promise<Folder> =>
  toFolder((await addItem(id, { quizsetId, confirmSourcePublication })).data);

export const removeFolderItem = async (
  id: string,
  quizsetId: string,
): Promise<Folder> => toFolder((await removeItem(id, quizsetId)).data);

/**
 * 이미 받은 첫 페이지에서 커서를 끝까지 따라가 폴더에 든 퀴즈 ID 전부를 모은다.
 *
 * 저장 뒤 서버 상태를 확인할 때 쓴다 — 첫 페이지(20개)만으로는 뒷 페이지의 퀴즈를 놓친다. 커서가 되돌거나 모은 수가
 * `quizsetCount` 와 다르면 던진다. 일부만 모은 목록으로 판단하지 않게 하기 위해서다.
 */
export const collectFolderItemIds = async (
  first: Folder,
): Promise<string[]> => {
  const ids = first.items.map(item => item.quizsetId);
  const seenCursors = new Set<string>();
  let cursor = first.nextCursor;
  while (cursor) {
    if (seenCursors.has(cursor)) throw new Error('Repeated folder cursor');
    seenCursors.add(cursor);
    const page = await fetchFolderDetail(first.id, cursor);
    ids.push(...page.items.map(item => item.quizsetId));
    cursor = page.nextCursor;
  }
  if (ids.length !== first.quizsetCount)
    throw new Error('Incomplete folder item refetch');
  return ids;
};
